<template>
    <section class="dp-layout psychology-config-page">
        <!-- 左侧学校树 -->
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <!-- 右侧配置区域 -->
        <section class="dp-right">
            <template v-if="hasSchoolSelected">
                <!-- 顶部学校及校区切换栏 -->
                <div class="header-bar">
                    <div class="school-info">
                        <span class="label">当前学校：</span>
                        <span class="value">{{ schoolName || '未命名学校' }}</span>
                    </div>
                    <div class="campus-selector">
                        <span class="label">选择校区：</span>
                        <el-select v-model="campusId" placeholder="请选择校区" size="small" class="campus-select" @change="handleCampusChange">
                            <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
                        </el-select>
                        <el-button
                            class="copy-campus-btn"
                            size="small"
                            type="primary"
                            plain
                            icon="el-icon-document-copy"
                            :disabled="!campusId || campusOptions.length <= 1"
                            @click="openCopyDialog"
                        >
                            复制其他校区配置
                        </el-button>
                    </div>
                </div>

                <div v-if="!campusId" class="no-campus-tip">
                    <i class="el-icon-info"></i>
                    <span>请先在上方下拉框中选择要配置的校区</span>
                </div>

                <el-card v-else class="config-card" shadow="never" v-loading="loading">
                        <div slot="header" class="card-header">
                            <div class="header-title">
                                <i class="el-icon-first-aid-kit" style="color: #409EFF; margin-right: 6px;"></i>
                                <span class="title">校区心理功能与时段配置</span>
                            </div>
                            <el-button type="primary" size="small" icon="el-icon-check" :loading="saving" @click="handleSave">
                                保存配置
                            </el-button>
                        </div>

                        <!-- 1. 功能开关设置 -->
                        <div class="setting-section">
                            <div class="setting-section__head">
                                <span class="setting-section__title">业务功能启用</span>
                                <span class="setting-section__desc">控制该校区是否在教师端/班主任端开放对应心理业务入口</span>
                            </div>

                            <div class="setting-grid">
                                <!-- 心理预约功能 -->
                                <div class="setting-tile">
                                    <div class="tile-top">
                                        <div class="tile-label">
                                            <i class="el-icon-date"></i>心理预约功能
                                        </div>
                                        <div class="tile-control">
                                            <el-switch v-model="configForm.EnableAppointment" active-text="开启" inactive-text="关闭" />
                                        </div>
                                    </div>
                                    <p class="tile-tip">开启后，班主任可在 H5 端发起心理咨询预约，由心理老师审核并核验签到。</p>
                                </div>

                                <!-- 心理预警登记功能 -->
                                <div class="setting-tile">
                                    <div class="tile-top">
                                        <div class="tile-label">
                                            <i class="el-icon-document"></i>学生心理档案
                                        </div>
                                        <div class="tile-control">
                                            <el-switch v-model="configForm.EnableStudentPsychArchive" active-text="开启" inactive-text="关闭" />
                                        </div>
                                    </div>
                                    <p class="tile-tip">开启后，家长、班主任、心理老师可填写并浏览三角色心理档案纸表。</p>
                                </div>
                            </div>
                        </div>

                        <div class="setting-section" v-if="configForm.EnableStudentPsychArchive">
                            <div class="setting-section__head">
                                <span class="setting-section__title">手写签名开关</span>
                                <span class="setting-section__desc">按角色控制预览页是否显示手写板；关闭后填完预览即可保存</span>
                            </div>
                            <div class="setting-grid">
                                <div class="setting-tile">
                                    <div class="tile-top">
                                        <div class="tile-label">家长表签名</div>
                                        <div class="tile-control">
                                            <el-switch v-model="configForm.EnableParentSignature" active-text="开启" inactive-text="关闭" />
                                        </div>
                                    </div>
                                </div>
                                <div class="setting-tile">
                                    <div class="tile-top">
                                        <div class="tile-label">班主任表签名</div>
                                        <div class="tile-control">
                                            <el-switch v-model="configForm.EnableHomeroomSignature" active-text="开启" inactive-text="关闭" />
                                        </div>
                                    </div>
                                </div>
                                <div class="setting-tile">
                                    <div class="tile-top">
                                        <div class="tile-label">心理老师表签名</div>
                                        <div class="tile-control">
                                            <el-switch v-model="configForm.EnablePsychSignature" active-text="开启" inactive-text="关闭" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="setting-section" v-if="configForm.EnableStudentPsychArchive">
                            <div class="setting-section__head">
                                <span class="setting-section__title">等级处理指引</span>
                                <span class="setting-section__desc">心理老师表右侧一类/二类/三类处理指引，提交时写入该次快照</span>
                            </div>
                            <el-form label-width="120px" style="max-width: 860px;">
                                <el-form-item label="一类处理指引">
                                    <el-input v-model="configForm.Level1GuideText" type="textarea" :rows="4" placeholder="一类处理指引原文" />
                                </el-form-item>
                                <el-form-item label="二类处理指引">
                                    <el-input v-model="configForm.Level2GuideText" type="textarea" :rows="4" placeholder="二类处理指引原文" />
                                </el-form-item>
                                <el-form-item label="三类处理指引">
                                    <el-input v-model="configForm.Level3GuideText" type="textarea" :rows="4" placeholder="三类处理指引原文" />
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- 2. 预约时段模式配置 -->
                        <div class="setting-section" v-if="configForm.EnableAppointment">
                            <div class="setting-section__head">
                                <span class="setting-section__title">预约时段模式与考勤联动</span>
                                <span class="setting-section__desc">配置心理咨询排期方式，并决定是否在签到时自动联动特殊课程点名考勤</span>
                            </div>

                            <div class="mode-selection-box">
                                <el-radio-group v-model="configForm.TimeMode" size="medium" @change="handleTimeModeChange">
                                    <el-radio-button :label="1">
                                        <i class="el-icon-connection"></i> 特殊课程时段（联动点名考勤）
                                    </el-radio-button>
                                    <el-radio-button :label="2">
                                        <i class="el-icon-time"></i> 自行选择时间（不改考勤）
                                    </el-radio-button>
                                </el-radio-group>
                            </div>

                            <!-- 模式 1 的说明与默认关联时段 -->
                            <div v-if="configForm.TimeMode === 1" class="mode-detail-card">
                                <div class="mode-tip-bar">
                                    <i class="el-icon-warning"></i>
                                    <span>
                                        【特殊课程时段模式】下，班主任发起预约时将直接选择学校设置的特殊课程（如夜自修/晚托）。
                                        学生在咨询室现场完成人脸核验签到后，系统将自动把该学生当期特殊课程考勤更新为<b>【其他（心理咨询）】</b>。
                                    </span>
                                </div>

                                <el-form label-width="150px" style="margin-top: 18px; max-width: 600px;">
                                    <el-form-item label="默认推荐时段">
                                        <el-select v-model="configForm.DefaultSpecialCourseTimeId" placeholder="请选择默认特殊课程时段" style="width: 100%;" clearable>
                                            <el-option v-for="t in specialCourseTimes" :key="t.Id" :label="t.DisplayName" :value="t.Id" />
                                        </el-select>
                                        <span class="sub-hint">班主任在移动端发起预约时将默认预选该时段，班主任也可自行切换为其他时段</span>
                                    </el-form-item>
                                </el-form>
                            </div>

                            <!-- 模式 2 的说明 -->
                            <div v-else class="mode-detail-card mode-detail-card--simple">
                                <div class="mode-tip-bar mode-tip-bar--info">
                                    <i class="el-icon-info"></i>
                                    <span>
                                        【自行选择时间模式】下，班主任自由选定具体的预约起止时间（如 14:30 - 15:30）。
                                        学生现场签到仅记录咨询室到访时间，<b>不变更任何课堂考勤点名状态</b>。
                                    </span>
                                </div>
                            </div>
                    </div>
                </el-card>
            </template>

            <!-- 未选择学校提示 -->
            <div v-else class="no-department-tip">
                <div class="no-department-tip__inner">
                    <i class="el-icon-school"></i>
                    <p>请在左侧选择所属学校，查看与配置校区心理功能</p>
                </div>
            </div>

            <!-- 复制其他校区配置弹窗 -->
            <el-dialog
                title="复制其他校区心理配置"
                :visible.sync="copyDialogVisible"
                width="620px"
                append-to-body
                :destroy-on-close="true"
                :close-on-click-modal="false"
                custom-class="psychology-copy-dialog"
                top="10vh"
            >
                <div class="copy-dialog-content">
                    <el-alert
                        title="说明：支持将其他校区成熟的配置一键复制并覆盖到当前校区。历史已填写的学生档案不受影响。"
                        type="info"
                        show-icon
                        :closable="false"
                        style="margin-bottom: 18px;"
                    />

                    <el-form label-width="110px" size="small" class="copy-form">
                        <el-form-item label="当前目标校区">
                            <el-tag size="medium" type="success" effect="plain" style="font-weight: bold;">
                                {{ currentCampusName || '未选定' }}
                            </el-tag>
                            <span class="text-muted" style="margin-left: 8px; font-size: 12px;">(配置将覆盖此校区)</span>
                        </el-form-item>

                        <el-form-item label="选择来源校区" required>
                            <el-select
                                v-model="copySourceCampusId"
                                placeholder="请选择作为模板的来源校区"
                                style="width: 100%;"
                                :disabled="sourceCampusOptions.length === 0"
                            >
                                <el-option
                                    v-for="item in sourceCampusOptions"
                                    :key="item.Id"
                                    :label="item.Name"
                                    :value="item.Id"
                                />
                            </el-select>
                            <div v-if="sourceCampusOptions.length === 0" style="color: #e6a23c; font-size: 12px; margin-top: 4px; line-height: 1.4;">
                                <i class="el-icon-warning"></i> 当前学校暂无其他可选校区作为模板
                            </div>
                        </el-form-item>

                        <el-form-item label="复制内容范围" required>
                            <div class="copy-scope-box">
                                <div class="scope-header">
                                    <el-checkbox
                                        v-model="copyCheckAll"
                                        :indeterminate="isCopyIndeterminate"
                                        @change="handleCopyCheckAllChange"
                                    >
                                        全选所有配置
                                    </el-checkbox>
                                </div>
                                <div class="scope-list">
                                    <el-checkbox v-model="copyScope.copyCampusConfig" @change="handleCopyScopeChange">
                                        <span class="scope-main">1. 业务功能开关与时段模式</span>
                                        <span class="scope-hint">预约/档案开启状态、签名与处理指引</span>
                                    </el-checkbox>
                                    <el-checkbox v-model="copyScope.copyAppointmentFields" @change="handleCopyScopeChange">
                                        <span class="scope-main">2. 心理预约表单字段</span>
                                        <span class="scope-hint">填报字段、必填、显隐与排序</span>
                                    </el-checkbox>
                                    <el-checkbox v-model="copyScope.copyArchiveParentFields" @change="handleCopyScopeChange">
                                        <span class="scope-main">3. 家长表字段</span>
                                        <span class="scope-hint">学生心理档案</span>
                                    </el-checkbox>
                                    <el-checkbox v-model="copyScope.copyArchiveHomeroomFields" @change="handleCopyScopeChange">
                                        <span class="scope-main">4. 班主任表字段</span>
                                        <span class="scope-hint">危机预警登记表</span>
                                    </el-checkbox>
                                    <el-checkbox v-model="copyScope.copyArchivePsychFields" @change="handleCopyScopeChange">
                                        <span class="scope-main">5. 心理老师表字段</span>
                                        <span class="scope-hint">高危干预方案</span>
                                    </el-checkbox>
                                    <el-checkbox v-model="copyScope.copyDictItems" @change="handleCopyScopeChange">
                                        <span class="scope-main">6. 表单选项字典库</span>
                                        <span class="scope-hint">危机筛查、病史、学习情况等选项</span>
                                    </el-checkbox>
                                    <el-checkbox v-model="copyScope.copyGuideTexts" @change="handleCopyScopeChange">
                                        <span class="scope-main">7. 三类处理指引文案</span>
                                        <span class="scope-hint">心理老师表右侧说明</span>
                                    </el-checkbox>
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>

                    <div class="copy-warning-footer">
                        <i class="el-icon-warning" style="color: #E6A23C; margin-right: 4px;"></i>
                        <span>注意：复制执行后将使用来源校区数据替换目标校区已勾选的配置，请谨慎操作。</span>
                    </div>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="copyDialogVisible = false">取 消</el-button>
                    <el-button
                        size="small"
                        type="primary"
                        :loading="copying"
                        :disabled="!copySourceCampusId || sourceCampusOptions.length === 0"
                        @click="confirmCopyConfig"
                    >
                        确认复制并覆盖
                    </el-button>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import { getCampusList } from '../../api/modules/psychology';
import {
    getPsychologyCampusConfig,
    savePsychologyCampusConfig,
    getPsychologySpecialCourseTimes,
    copyCampusPsychologyConfig
} from '../../api/modules/psychology';
import {
    resolveActiveSchoolId,
    normalizeDeptId,
    treeNodeDeptId,
    deptIdsEqual,
} from '../../utils/deptCascaderProps';

export default {
    name: 'PsychologyCampusConfig',
    components: { DepartmentPane },
    data() {
        return {
            schoolId: '',
            schoolName: '',
            campusId: null,
            campusOptions: [],
            specialCourseTimes: [],
            loading: false,
            saving: false,

            // 复制配置
            copyDialogVisible: false,
            copySourceCampusId: null,
            copying: false,
            copyCheckAll: true,
            isCopyIndeterminate: false,
            copyScope: {
                copyCampusConfig: true,
                copyAppointmentFields: true,
                copyArchiveParentFields: true,
                copyArchiveHomeroomFields: true,
                copyArchivePsychFields: true,
                copyDictItems: true,
                copyGuideTexts: true
            },

            configForm: {
                Id: 0,
                SchoolId: 0,
                CampusId: 0,
                EnableAppointment: false,
                EnableStudentPsychArchive: false,
                EnableParentSignature: false,
                EnableHomeroomSignature: false,
                EnablePsychSignature: false,
                Level1GuideText: '',
                Level2GuideText: '',
                Level3GuideText: '',
                TimeMode: 2,
                DefaultSpecialCourseTimeId: null
            }
        };
    },
    computed: {
        currentCampusName() {
            const curId = String(this.campusId || '');
            const found = (this.campusOptions || []).find(c => {
                const cid = String(c.Id != null ? c.Id : (c.id != null ? c.id : (c.value != null ? c.value : '')));
                return cid === curId;
            });
            return found ? (found.Name || found.name || found.label || '当前校区') : '';
        },
        sourceCampusOptions() {
            const curId = String(this.campusId || '');
            return (this.campusOptions || []).filter(c => {
                const cid = String(c.Id != null ? c.Id : (c.id != null ? c.id : (c.value != null ? c.value : '')));
                return cid && cid !== curId;
            }).map(c => ({
                Id: String(c.Id != null ? c.Id : (c.id != null ? c.id : c.value)),
                Name: c.Name || c.name || c.label || '未命名校区'
            }));
        }
    },
    computed: {
        hasSchoolSelected() {
            return !!normalizeDeptId(this.schoolId);
        },
    },
    watch: {
        '$store.state.activeSchoolId'(newVal) {
            const id = normalizeDeptId(newVal);
            if (id && !deptIdsEqual(id, this.schoolId)) {
                this.schoolId = id;
                this.campusId = null;
                this.campusOptions = [];
                this.loadCampusOptions();
            }
        }
    },
    methods: {
        // ================= 复制其他校区配置 =================

        openCopyDialog() {
            if (!this.campusId) {
                this.$message.warning('请先选择当前目标校区');
                return;
            }
            if (this.sourceCampusOptions.length === 0) {
                this.$message.warning('当前学校仅有 1 个校区，暂无可供复制的模板校区');
                return;
            }
            this.copySourceCampusId = null;
            this.copyCheckAll = true;
            this.isCopyIndeterminate = false;
            this.copyScope = {
                copyCampusConfig: true,
                copyAppointmentFields: true,
                copyArchiveParentFields: true,
                copyArchiveHomeroomFields: true,
                copyArchivePsychFields: true,
                copyDictItems: true,
                copyGuideTexts: true
            };
            this.copyDialogVisible = true;
        },

        handleCopyCheckAllChange(val) {
            this.copyScope = {
                copyCampusConfig: val,
                copyAppointmentFields: val,
                copyArchiveParentFields: val,
                copyArchiveHomeroomFields: val,
                copyArchivePsychFields: val,
                copyDictItems: val,
                copyGuideTexts: val
            };
            this.isCopyIndeterminate = false;
        },

        handleCopyScopeChange() {
            const values = Object.values(this.copyScope);
            const trueCount = values.filter(Boolean).length;
            this.copyCheckAll = trueCount === values.length;
            this.isCopyIndeterminate = trueCount > 0 && trueCount < values.length;
        },

        async confirmCopyConfig() {
            if (!this.copySourceCampusId) {
                this.$message.warning('请选择来源校区');
                return;
            }
            const hasChecked = Object.values(this.copyScope).some(Boolean);
            if (!hasChecked) {
                this.$message.warning('请至少勾选一项需要复制的配置内容');
                return;
            }

            const sourceCampus = this.campusOptions.find(c => c.Id === this.copySourceCampusId);
            const sourceName = sourceCampus ? sourceCampus.Name : '所选校区';
            const targetName = this.currentCampusName;

            try {
                await this.$confirm(
                    `确定要将【${sourceName}】的配置复制并覆盖到当前【${targetName}】吗？此操作无法撤销。`,
                    '复制确认',
                    {
                        confirmButtonText: '确定覆盖',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                );
            } catch (e) {
                return;
            }

            this.copying = true;
            try {
                const res = await copyCampusPsychologyConfig({
                    schoolId: this.schoolId,
                    sourceCampusId: this.copySourceCampusId,
                    targetCampusId: this.campusId,
                    copyCampusConfig: this.copyScope.copyCampusConfig,
                    copyAppointmentFields: this.copyScope.copyAppointmentFields,
                    copyArchiveParentFields: this.copyScope.copyArchiveParentFields,
                    copyArchiveHomeroomFields: this.copyScope.copyArchiveHomeroomFields,
                    copyArchivePsychFields: this.copyScope.copyArchivePsychFields,
                    copyDictItems: this.copyScope.copyDictItems,
                    copyGuideTexts: this.copyScope.copyGuideTexts
                });

                if (res && res.data && res.data.success) {
                    this.$message.success('配置复制成功！已自动加载最新配置');
                    this.copyDialogVisible = false;
                    // 重新刷新当前校区配置
                    this.loadCampusConfig();
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '复制失败');
                }
            } catch (error) {
                this.$message.error('复制出错: ' + (error.message || error));
            } finally {
                this.copying = false;
            }
        },

        /**
         * 解析当前选中的学校 Id
         */
        resolveSchoolId() {
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return fromStore;
            return normalizeDeptId(this.schoolId);
        },

        /**
         * 左侧学校树节点点击
         */
        treeNodeClick(data) {
            this.schoolId = treeNodeDeptId(data);
            this.schoolName = data.label || '';
            this.campusId = null;
            this.campusOptions = [];
            this.loadCampusOptions();
        },

        /**
         * 加载该学校下的校区列表
         */
        async loadCampusOptions() {
            if (!this.schoolId) return;
            try {
                const res = await getCampusList({ page: 1, intPageSize: 999, departmentId: this.schoolId });
                if (res.data && res.data.success) {
                    this.campusOptions = res.data.response.data || [];
                    if (this.campusOptions.length > 0) {
                        this.campusId = this.campusOptions[0].Id;
                        this.loadCampusConfig();
                    }
                }
            } catch (err) {
                this.$message.error('加载校区列表失败');
            }
        },

        /**
         * 校区下拉切换
         */
        handleCampusChange() {
            if (this.campusId) {
                this.loadCampusConfig();
            }
        },

        /**
         * 加载当前校区的配置数据与特殊课程时段
         */
        async loadCampusConfig() {
            if (!this.schoolId || !this.campusId) return;
            this.loading = true;
            try {
                // 并行加载配置和可用时段
                const [cfgRes, timeRes] = await Promise.all([
                    getPsychologyCampusConfig({ schoolId: this.schoolId, campusId: this.campusId }),
                    getPsychologySpecialCourseTimes({ schoolId: this.schoolId, campusId: this.campusId })
                ]);

                if (cfgRes.data && cfgRes.data.success) {
                    const data = cfgRes.data.response;
                    this.configForm = {
                        Id: data.Id || 0,
                        SchoolId: this.schoolId,
                        CampusId: this.campusId,
                        EnableAppointment: !!data.EnableAppointment,
                        EnableStudentPsychArchive: !!data.EnableStudentPsychArchive,
                        EnableParentSignature: !!data.EnableParentSignature,
                        EnableHomeroomSignature: !!data.EnableHomeroomSignature,
                        EnablePsychSignature: !!data.EnablePsychSignature,
                        Level1GuideText: data.Level1GuideText || '',
                        Level2GuideText: data.Level2GuideText || '',
                        Level3GuideText: data.Level3GuideText || '',
                        TimeMode: data.TimeMode || 2,
                        DefaultSpecialCourseTimeId: data.DefaultSpecialCourseTimeId || null
                    };
                }

                if (timeRes.data && timeRes.data.success) {
                    this.specialCourseTimes = timeRes.data.response || [];
                }
            } catch (err) {
                this.$message.error('获取校区心理配置失败');
            } finally {
                this.loading = false;
            }
        },

        /**
         * 时段模式切换
         */
        handleTimeModeChange(val) {
            if (val === 2) {
                this.configForm.DefaultSpecialCourseTimeId = null;
            }
        },

        /**
         * 保存当前校区配置
         */
        async handleSave() {
            if (!this.schoolId || !this.campusId) {
                this.$message.warning('请选择所属学校和校区');
                return;
            }

            this.saving = true;
            try {
                const payload = {
                    ...this.configForm,
                    SchoolId: this.schoolId,
                    CampusId: this.campusId
                };
                const res = await savePsychologyCampusConfig(payload);
                if (res.data && res.data.success) {
                    this.$message.success('心理配置保存成功');
                    this.loadCampusConfig();
                } else {
                    this.$message.error(res.data ? res.data.msg : '保存配置失败');
                }
            } catch (err) {
                this.$message.error('保存失败，请稍后重试');
            } finally {
                this.saving = false;
            }
        }
    },
    mounted() {
        const defaultSchoolId = this.resolveSchoolId();
        if (defaultSchoolId) {
            this.schoolId = defaultSchoolId;
            this.loadCampusOptions();
        }
    }
};
</script>

<style scoped>
.header-bar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 14px;
    background: #f8fafc;
    border: 1px solid #eef2f6;
    border-radius: 6px;
    margin-bottom: 8px;
}

.school-info .label,
.campus-selector .label {
    font-size: 14px;
    color: #606266;
    line-height: 32px;
    white-space: nowrap;
}

.school-info .value {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.campus-selector {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.campus-select {
    width: 200px;
}

.copy-campus-btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    height: 32px;
    line-height: 1 !important;
    padding: 0 12px !important;
    vertical-align: middle;
}

.copy-campus-btn >>> [class^="el-icon-"] {
    margin-right: 4px;
    line-height: 1;
    font-size: 14px;
}

.config-card {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border: 1px solid #e8edf5;
    border-radius: 6px;
    overflow: hidden;
}

.config-card >>> .el-card__header {
    padding: 10px 16px;
    background: #fafcff;
    border-bottom: 1px solid #f0f3f8;
    flex-shrink: 0;
}

.config-card >>> .el-card__body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 12px 16px;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-title .title {
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.setting-section {
    padding: 12px 0;
    border-bottom: 1px solid #f0f2f5;
}

.setting-section:first-child {
    padding-top: 0;
}

.setting-section:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.setting-section__head {
    margin-bottom: 10px;
}

.setting-section__title {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    display: inline-block;
    margin-right: 12px;
}

.setting-section__desc {
    font-size: 13px;
    color: #64748b;
}

.setting-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 12px;
}

.setting-tile {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 10px 14px;
    transition: all 0.2s;
}

.setting-tile:hover {
    border-color: #cbd5e1;
}

.tile-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tile-label {
    font-size: 14px;
    font-weight: 500;
    color: #334155;
}

.tile-label i {
    color: #409EFF;
    margin-right: 6px;
    font-size: 15px;
}

.tile-tip {
    font-size: 12px;
    color: #64748b;
    margin-top: 6px;
    margin-bottom: 0;
    line-height: 1.5;
}

.mode-selection-box {
    margin-bottom: 10px;
}

.mode-detail-card {
    background: #fffbeb;
    border: 1px solid #fef3c7;
    border-radius: 6px;
    padding: 12px 16px;
}

.mode-detail-card--simple {
    background: #f8fafc;
    border-color: #e2e8f0;
}

.mode-tip-bar {
    display: flex;
    align-items: flex-start;
    font-size: 13px;
    color: #d97706;
    line-height: 1.6;
}

.mode-tip-bar--info {
    color: #64748b;
}

.mode-tip-bar i {
    font-size: 16px;
    margin-right: 8px;
    margin-top: 2px;
    flex-shrink: 0;
}

.sub-hint {
    font-size: 12px;
    color: #909399;
    display: block;
    line-height: 1.4;
    margin-top: 4px;
}

.no-campus-tip,
.no-department-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 200px;
    color: #909399;
}

.no-campus-tip i,
.no-department-tip i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #c0c4cc;
}

.copy-dialog-content {
    padding: 0 4px;
    overflow-x: hidden;
}

.copy-scope-box {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 10px 14px;
    background-color: #FAFAFA;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
}

.scope-header {
    border-bottom: 1px solid #EBEEF5;
    padding-bottom: 8px;
    margin-bottom: 8px;
}

.scope-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.scope-main {
    display: block;
    color: #303133;
    line-height: 1.4;
}

.scope-hint {
    display: block;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 2px;
    font-weight: normal;
}

.copy-warning-footer {
    margin-top: 14px;
    padding: 10px 12px;
    background: #FDF6EC;
    border: 1px solid #FAECD8;
    border-radius: 4px;
    color: #E6A23C;
    font-size: 12px;
    line-height: 1.5;
}
</style>

<style>
/* 与 FormConfig 共用 psychology-copy-dialog；此处保持一致避免单独进本页时缺样式 */
.psychology-copy-dialog .el-dialog__body {
    overflow-x: hidden;
    padding-top: 14px;
    padding-bottom: 10px;
}
.psychology-copy-dialog .copy-dialog-content {
    padding: 0 4px;
    overflow-x: hidden;
}
.psychology-copy-dialog .copy-form .el-form-item__content {
    line-height: normal;
    overflow: hidden;
}
.psychology-copy-dialog .copy-scope-box {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 10px 14px;
    background-color: #FAFAFA;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow: hidden;
}
.psychology-copy-dialog .scope-header {
    border-bottom: 1px solid #EBEEF5;
    padding-bottom: 8px;
    margin-bottom: 8px;
}
.psychology-copy-dialog .scope-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.psychology-copy-dialog .scope-list .el-checkbox {
    display: flex;
    align-items: flex-start;
    margin-right: 0;
    white-space: normal;
    height: auto;
    width: 100%;
}
.psychology-copy-dialog .scope-list .el-checkbox__input {
    margin-top: 3px;
    flex-shrink: 0;
}
.psychology-copy-dialog .scope-list .el-checkbox__label {
    white-space: normal;
    line-height: 1.4;
    flex: 1;
    min-width: 0;
    word-break: break-word;
    padding-left: 8px;
}
.psychology-copy-dialog .scope-main {
    display: block;
    color: #303133;
    line-height: 1.4;
}
.psychology-copy-dialog .scope-hint {
    display: block;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 2px;
    font-weight: normal;
}
.psychology-copy-dialog .copy-warning-footer {
    margin-top: 14px;
    padding: 10px 12px;
    background: #FDF6EC;
    border: 1px solid #FAECD8;
    border-radius: 4px;
    color: #E6A23C;
    font-size: 12px;
    line-height: 1.5;
}
</style>
